import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { cloneDeep } from 'lodash';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { OrganizationUnit } from 'src/app/misc/interface/organization-unit';
import { Message, ConfirmationService, ConfirmEventType, MenuItem } from 'primeng/api';

@Component({
  selector: 'app-ms-session',
  templateUrl: './ms-session.component.html',
  styleUrls: ['./ms-session.component.scss','../../../../mystery-shopper/mystery-shopper.component.scss' ]

})
export class MsSessionComponent {
  header = this.translate('MSSessions');
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-refresh',
      link: '/ms/project',
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Project'), link: '/ms/project' },
    { name: this.translate('MSSessions'), link: '/ms/session' },
  ];
  queryParams: any = {};
  stats: stat[] = [];
  startDate: any;
  endDate:any;
  messages: Message[] = [];
  sessions: any[] = [];
  isEdit: boolean = false;
  editSessionId: string = "";
  projectId :string =  '';
  minDate: Date = new Date();
  sessionName: string = ""
  
  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.projectId = params['projectId'];
      if (this.projectId) {
        this.clearForm();
        Promise.all([this.fetchSessions()]);
      }
    })
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  private async fetchSessions(): Promise<void> {
    let res = await this.dataService.getData(`ms-sessions/project/1/1000/` + this.projectId);
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.sessions = res.data;
  }

  isFormValid(): boolean {
    return (
      this.startDate !== '' &&
      this.endDate !== '' &&
      this.sessionName !== ''
    );
  }

  clearForm() {
    this.startDate = "";
    this.endDate = '';
    this.sessionName = "";
  }

  async createSession() {
    
    if (this.isFormValid()) {
        try {

          let startDate = new Date(this.startDate);
          let endDate = new Date(this.endDate);
          let session : any = {
            name: this.sessionName,
            startDate: startDate,
            endDate: endDate,
            projectId: this.projectId,
          }
          let res;
          if (this.isEdit)
          {
            res = await this.dataService.postData('ms-sessions/' + this.editSessionId, session,'PUT',false);
            this.isEdit = false;
          } else{
            session.visits = { data: [] };
            res = await this.dataService.postData('ms-sessions', session);
          }
          if (res.error) return
          this.ngOnInit();
        } catch (error) {
          console.log(error)
        }
    }
    else{
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate("Please Provide all Valid Data") },
      ];
      return;
    }
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day}-${month}-${year}`;
  }

  loadSession(session: any) {
    this.isEdit = true;
    this.editSessionId = session._id;
    this.sessionName   = session.name; 
    this.startDate     = new Date(session.startDate);
    this.endDate     = new Date(session.endDate);
  }

  deleteSession(sessionId: string, $event: any){
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let res = await this.dataService.deleteData(`ms-sessions/${sessionId}`);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
        } catch (error) {
          console.log(error);
        }
      },
    });

  }

  cancelEdit() {
    this.clearForm();
    this.isEdit = false;
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

}
